import React from "react";
import { useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import HeadsetMicOutlined from "@material-ui/icons/HeadsetMicOutlined";
import { brand } from "../../styles/brand";

const useStyles = makeStyles((theme) => ({
  chatContainer: {
    flex: 1,
    height: `calc(100% - 66px)`,
    overflowY: "hidden",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: { padding: 0 },
  },

  chatPapper: {
    display: "flex",
    height: "100%",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(16, 68, 99, .08)",
    [theme.breakpoints.down("sm")]: { borderRadius: 0, borderLeft: 0, borderRight: 0 },
  },

  contactsWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
  },
  contactsWrapperSmall: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflowY: "hidden",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  messagessWrapper: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    borderLeft: `1px solid ${theme.palette.divider}`,
  },
  welcomeMsg: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    textAlign: "center",
    borderRadius: 0,
    color: theme.palette.text.secondary,
    background: theme.palette.type === "dark"
      ? "radial-gradient(circle at center, #143A50 0%, #0E2B3E 72%)"
      : "radial-gradient(circle at center, #FFFFFF 0%, #F4FAFD 72%)",
  },
  welcomeIcon: {
    width: 78,
    height: 78,
    padding: 19,
    marginBottom: theme.spacing(2),
    color: brand.sky,
    borderRadius: 24,
    backgroundColor: theme.palette.type === "dark" ? "rgba(20,169,229,.12)" : "#E7F6FC",
  },
  welcomeTitle: { color: theme.palette.text.primary, fontWeight: 800 },
  welcomeText: { maxWidth: 350, marginTop: theme.spacing(1) },
  ticketsManager: {},
  ticketsManagerClosed: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const Chat = () => {
  const classes = useStyles();
  const { ticketId } = useParams();

  return (
    <div className={classes.chatContainer}>
      <div className={classes.chatPapper}>
        <Grid container spacing={0}>
          {/* <Grid item xs={4} className={classes.contactsWrapper}> */}
          <Grid
            item
            xs={12}
            md={4}
            className={
              ticketId ? classes.contactsWrapperSmall : classes.contactsWrapper
            }
          >
            <TicketsManager />
          </Grid>
          <Grid item xs={12} md={8} className={classes.messagessWrapper}>
            {/* <Grid item xs={8} className={classes.messagessWrapper}> */}
            {ticketId ? (
              <>
                <Ticket />
              </>
            ) : (
              <Hidden only={["sm", "xs"]}>
                <Paper className={classes.welcomeMsg} elevation={0}>
                  <HeadsetMicOutlined className={classes.welcomeIcon} />
                  <Typography variant="h5" className={classes.welcomeTitle}>
                    Centro de conversaciones
                  </Typography>
                  <Typography className={classes.welcomeText}>
                    {i18n.t("chat.noTicketMessage")}
                  </Typography>
                </Paper>
              </Hidden>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default Chat;
